<script>
    import { onMount } from "svelte";
    import axios from "axios";

    onMount(async () => {
        await axios
            .delete(APIBACKEND + "/user", { withCredentials: true })
            .then(function (res) {
                window.location.replace("/");
            })
            .catch((error) => {
                window.location.replace("/");
            });
    });
</script>
